/* eslint-disable @typescript-eslint/no-explicit-any */
// import { MakeGenerics, useNavigate, useSearch } from "react-location";
import { useSearchParams } from "react-router-dom";
import { getPairs } from "./helpers";
import { useEffect } from "react";

export default function useUrlState<T = any>(
  field: string,
  defaultValue?: T
): [T, (val: T) => void] {
  // console.log("called", field);
  const [searchParms, setSearch] = useSearchParams();

  const setState = (newState: Partial<T>) => {
    setSearch(() => ({
      ...getPairs(searchParms, field, newState),
    }));
  };
  if (defaultValue && !searchParms.has(field)) {
    setState(defaultValue);
  }

  useEffect(() => {
    if (!searchParms.has(field) && defaultValue) {
      setState(defaultValue as T);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return [searchParms.get(field) as T, setState];
}
